import React from "react";
import useCategory from "../adminDashboard/category/useCategory";
import { Link } from "react-router-dom";
import CustomLoading from "../../utils/LoadingIndicator/CustomLoading";

function Category() {
  const { categories, isGettingCategories, errorGettingCategories } =
    useCategory();
  if (isGettingCategories) return <CustomLoading />;
  if (errorGettingCategories)
    return (
      <h3 className="text-red-600 text-xl text-center block w-full">
        Error Getting Categories
      </h3>
    );
  return (
    <div
      className="w-screen bg-gradient-to-b from-white to-gray-100 ml-0 py-12"
      id="categories"
    >
      <div className="container mx-auto px-4 sm:px-8">
        <h2 className="text-3xl font-bold mb-8 text-left uppercase tracking-wide">
          Categories
        </h2>
        <div
          className={`
          
          gap-6
          md:justify-center
          w-full
          items-center
          mx-auto
          flex
          overflow-auto
          pb-8
        `}
        >
          {categories?.map((category) => (
            <Link
              key={category._id}
              to={`/category/${category._id}/products`}
              className="flex min-w-[10rem] h-[10rem] flex-1 flex-col items-center bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 p-6 group"
            >
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-red-200 transition">
                <span className="text-3xl font-bold text-red-600">
                  {category.name[0]}
                </span>
              </div>
              <span className="text-lg font-semibold text-gray-800 group-hover:text-red-600 transition text-center break-words">
                {category.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Category;
